module.exports = __webpack_public_path__ + "static/media/pro.a48c916e.JPG";